import { render, staticRenderFns } from "./index-old.vue?vue&type=template&id=34e9b068&scoped=true"
import script from "./index-old.vue?vue&type=script&lang=js"
export * from "./index-old.vue?vue&type=script&lang=js"
import style0 from "./index-old.vue?vue&type=style&index=0&id=34e9b068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e9b068",
  null
  
)

export default component.exports